import { render } from "./EnterData.vue?vue&type=template&id=010268c7&scoped=true"
import script from "./EnterData.vue?vue&type=script&lang=js"
export * from "./EnterData.vue?vue&type=script&lang=js"

import "./EnterData.vue?vue&type=style&index=0&id=010268c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-010268c7"

export default script